module.exports = __webpack_public_path__ + "static/media/animated-bean-cans.c8496ff3.svg";